/**
 * Durable-within-the-tab analytics session id.
 *
 * Persisted per quiz slug in sessionStorage so a mid-quiz page refresh
 * continues the SAME funnel session instead of minting a new one — without
 * persistence every refresh looked like a fresh visitor who instantly dropped
 * off, inflating starts and depressing completion rates. sessionStorage (not
 * localStorage) is deliberate: a tab is a session; a return visit tomorrow is
 * a new one.
 */
const KEY_PREFIX = "qk-session:";

function freshId(): string {
  return typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function resolveSessionId(slug: string): string {
  // Storage can throw (Safari private mode, sandboxed iframes, disabled
  // cookies): fall back to a per-mount id, which is the old behaviour.
  const key = KEY_PREFIX + slug;
  try {
    const existing = window.sessionStorage.getItem(key);
    if (existing) return existing;
  } catch {
    return freshId();
  }
  const id = freshId();
  try {
    window.sessionStorage.setItem(key, id);
  } catch {
    // Quota/full/blocked: still usable for this mount.
  }
  return id;
}
